var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "url(#arrow_svg__arrow-gradient)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14M5 12l6 6M5 12l6-6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "arrow_svg__arrow-gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "8%",
    stopColor: "#E02041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#4347FE"
  })))));
};
export default SvgArrow;